import store from "@/store/store";

export const publicCheckMixin = {
  beforeRouteEnter(to, from, next) {
    // Keep the environment variable stand-alone in a single variable. Or it will compile wrong.
    // Source: https://github.com/vuejs/vue-cli/issues/4015
    const isPublic = process.env.VUE_APP_IS_PUBLIC;
    if (isPublic === "true") {
      next();
      return;
    }

    if (!store.getters.isAuthenticated) {
      next({ name: "InlogMethode" });
      return;
    }

    next();
  }
};
